import {ERRORS} from '../../../index';


const {Component, State} = Shopware;

Component.extend('ecocode-trustpilot-send-delay-config', 'sw-number-field-deprecated', {
    emits:['update:value'],
    props: {
        value: {
            type: Number,
            default() {
                return 0;
            }
        },
        numberType: {
            type: String,
            default() {
                return 'int';
            }
        },
        min: {
            type: Number,
            default() {
                return 0;
            }
        },
        max: {
            type: Number,
            default() {
                return 90;
            }
        }
    },
    computed: {
        inputFieldEl() {
            try {
                return document.getElementById(this.formFieldName);
            } catch (e) {
                console.info('unable to get input field element')
            }
        },
        wrapperEl() {
            try {
                if(!this.inputFieldEl){
                    return null // can happen on component rerender state
                }
                // get component wrapper element
                return this.inputFieldEl
                    .parentElement
                    .parentElement
                    .parentElement
            } catch (e) {
                console.info('unable to get wrapper delay element')
            }
        },
        displayState() {
            return State.getters[this.$attrs.watchField];
        },

    },
    methods: {
        onInput(event) {
            this.validateValue(event.target.value);
        },
        validateValue(value) {
            if(!this.inputFieldEl){
               return // can happen on component rerender state
            }

            const isValid = value >= this.realMinimum && value <= this.realMaximum;
            this.inputFieldEl.style.color = isValid ? 'inherit' : ERRORS.INVALID_VALUE_COLOR_CODE;
        },
        checkWatcherField(fieldState) {
            if (this.$attrs.hasOwnProperty('watchField')) {

                if(!this.wrapperEl){
                    return // can happen on component rerender state
                }
                // hide component if active state is false
                this.wrapperEl.style.display = fieldState ? 'inherit' : 'none';
            }
        },
        handleNullValue(value) {
            // handle case if inheritance value is null, then set 0 as default
            value == null && this.$nextTick(() => {
                this.currentValue = this.parseValue(value);
            });
        },
        initEventListeners() {
            this.inputFieldEl &&
            this.inputFieldEl.addEventListener('blur', () => {
                this.validateValue(this.value)
            }, true);
        },
    },
    watch: {
        value(newValue) {
            this.validateValue(newValue);
        },
        displayState(displayState) {
            this.checkWatcherField(displayState);
        }
    },
    mounted() {
        // we need timer to allow render input fields otherwise we will get error
        setTimeout(() => {
            this.handleNullValue(this.value);
            this.validateValue(this.value);
            this.checkWatcherField(this.displayState);
        }, 0)

    },
    updated() {
        this.handleNullValue(this.value);
    }
})

